const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);

export const getSelectionPopoverPosition = ({
  layerBounds,
  viewportBounds,
  rightmostX,
  scrollLeft,
  layerHeight,
  popoverWidth = 136,
}) => {
  if (!layerBounds || !viewportBounds) return null;
  const visibleTop = Math.max(0, viewportBounds.top);
  const visibleBottom = Math.min(window.innerHeight, viewportBounds.bottom);
  if (layerBounds.bottom <= visibleTop || layerBounds.top >= visibleBottom) return null;

  const desiredLeft = layerBounds.left + rightmostX - scrollLeft + 10;
  const maximumLeft = Math.max(layerBounds.left + 8, layerBounds.right - popoverWidth);
  return {
    left: clamp(desiredLeft, layerBounds.left + 8, maximumLeft),
    top: clamp(
      layerBounds.top + layerHeight / 2,
      visibleTop + 8,
      Math.max(visibleTop + 8, visibleBottom - 8)
    ),
  };
};

export const observeSelectionGeometry = ({element, onChange}) => {
  if (!element || typeof onChange !== 'function') return () => {};
  const trackViewport = element.closest('[data-testid="annotation-track-lanes"]');
  let animationFrameId = null;
  const schedule = () => {
    if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
    animationFrameId = requestAnimationFrame(() => {
      animationFrameId = null;
      onChange();
    });
  };

  trackViewport?.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('scroll', schedule, true);
  window.addEventListener('resize', schedule);
  return () => {
    trackViewport?.removeEventListener('scroll', schedule);
    window.removeEventListener('scroll', schedule, true);
    window.removeEventListener('resize', schedule);
    if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
  };
};
